const iniOnboardingCrawler = {
    index: 0,
    moreCrawler: null,
    moreIndex: null
};

export default iniOnboardingCrawler;
